import { render, staticRenderFns } from "./TermoDesentranhamentoJuntarGenerico.vue?vue&type=template&id=b368799e&scoped=true"
import script from "./TermoDesentranhamentoJuntarGenerico.vue?vue&type=script&lang=js"
export * from "./TermoDesentranhamentoJuntarGenerico.vue?vue&type=script&lang=js"
import style0 from "./TermoDesentranhamentoJuntarGenerico.vue?vue&type=style&index=0&id=b368799e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b368799e",
  null
  
)

export default component.exports